export default {
    "template": "componentsCompany/astraTop/CompanySettings",
    "default_number_format": {
        "decimal_point": ",",
        "decimal_length": 2
    },
    "new_design": true,
    "menu_template": "componentsCompany/astraTop/header/MenuComponent"
}